var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { style: { backgroundColor: _vm.backgroundColor, color: _vm.textColor } },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }